import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import { getSortedResponses } from '../../reducer';
var RubriqSelectedCriteriaItemWrapper = function RubriqSelectedCriteriaItemWrapper(_ref) {
  var showClickableLink = _ref.showClickableLink,
    session = _ref.session,
    response = _ref.response,
    children = _ref.children;
  return showClickableLink ? /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/abstract-writer/".concat(session, "/criteria/").concat(response.step),
    className: "rubriq-selected-criteria-item-link"
  }, children) : /*#__PURE__*/React.createElement("div", null, children);
};
var RubriqSelectedCriteriaItem = function RubriqSelectedCriteriaItem(_ref2) {
  var session = _ref2.session,
    response = _ref2.response,
    showClickableLink = _ref2.showClickableLink,
    overrideIcon = _ref2.overrideIcon,
    truncateResponse = _ref2.truncateResponse;
  return /*#__PURE__*/React.createElement(RubriqSelectedCriteriaItemWrapper, {
    showClickableLink: showClickableLink,
    session: session,
    response: response
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-3 py-2 d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-2 align-items-center"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: overrideIcon !== null && overrideIcon !== void 0 ? overrideIcon : 'fa-solid fa-tag'
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column"
  }, response.step === 'text-limit' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5"
  }, /*#__PURE__*/React.createElement(T, {
    source: "length"
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary"
  }, /*#__PURE__*/React.createElement(T, {
    source: response.response.useCharacters ? 'n-characters' : 'n-words',
    params: response.response.maxLength
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "fw-semibold fs-5"
  }, /*#__PURE__*/React.createElement(T, {
    source: response.label
  })), /*#__PURE__*/React.createElement("span", {
    className: "text-secondary ".concat(truncateResponse ? 'w-50 text-truncate' : '')
  }, /*#__PURE__*/React.createElement(T, {
    source: response.response
  }))))), showClickableLink && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-caret-right",
    className: "rubriq-selected-criteria-item-link-icon rounded-circle p-2 fs-5"
  })));
};
var RubriqSelectedCriteria = function RubriqSelectedCriteria(_ref3) {
  var _ref3$showClickableLi = _ref3.showClickableLinks,
    showClickableLinks = _ref3$showClickableLi === void 0 ? true : _ref3$showClickableLi;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie;
  var _curie$abstractWriter = curie.abstractWriter,
    session = _curie$abstractWriter.session,
    title = _curie$abstractWriter.title;
  var sortedResponses = getSortedResponses({
    curie: curie
  });
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(RubriqSelectedCriteriaItem, {
    session: session,
    response: {
      step: 'onboarding',
      label: 'title',
      response: title
    },
    showClickableLink: showClickableLinks,
    overrideIcon: "fa-solid fa-text",
    truncateResponse: true
  }), sortedResponses.map(function (sortedResponse, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: sortedResponse.step,
      className: index === 0 ? 'border-top border-bottom' : 'border-bottom'
    }, /*#__PURE__*/React.createElement(RubriqSelectedCriteriaItem, {
      key: sortedResponse.step,
      session: session,
      response: sortedResponse,
      showClickableLink: showClickableLinks
    }));
  }));
};
export default RubriqSelectedCriteria;